import './tabbed-media-content.scss';

export default class TabbedMediaContent {
    constructor (tabbedElement) {
        if (!tabbedElement) return;

        this.tabbedElement = tabbedElement;
        this.tabbedElementWrapper = tabbedElement.querySelector('.js-tabbed-content-wrap');
        this.tabbedContent = this.tabbedElement.querySelectorAll('.js-tabbed-content');
        this.arrowNext = this.tabbedElement.querySelector('.swiper-button-next');
        this.arrowPrev = this.tabbedElement.querySelector('.swiper-button-prev');
        this.scrollbar = this.tabbedElement.querySelector('.swiper-scrollbar');
        this.tabbedToggles = this.tabbedElement.querySelectorAll('.js-tabbed-toggle');
        this.tabbedTogglesContainer = this.tabbedElement.querySelector('.js-collection-product-carousel-btns');
        this.tabbedNav = this.tabbedElement.querySelector('.js-tabbed-nav');
        this.tabIndicator = this.tabbedElement.querySelector('.js-tab-indicator');

        if (this.tabbedContent && this.tabbedToggles && this.tabbedToggles.length > 0) {
            const buttonType = this.tabbedToggles[0].dataset.type;
            this.tabbedContent.forEach((content) => {
                const slideType = content.dataset.type;
                if(buttonType == slideType) {
                    content.classList.add('active');
                } else {
                    content.classList.remove('active');
                }
            })
        }

        this.init()
    }

    init() {
        if (this.tabbedToggles && this.tabbedToggles.length > 0) {
            // Initialize first tab as active
            this.tabbedToggles[0].classList.add('active');
            this.updateLineIndicator(this.tabbedToggles[0]);

            this.tabbedToggles.forEach(button => {
                button.addEventListener('click', () => {
                    this.tabbedToggles.forEach(buttonRemove => {
                        buttonRemove.classList.remove('active')
                    });

                    button.classList.add('active');
                    this.updateLineIndicator(button);

                    // Keep the active tab in view by scrolling only the
                    // local tabs container, not the whole page.
                    if (this.tabbedTogglesContainer) {
                        const container = this.tabbedTogglesContainer;

                        if (container.scrollWidth > container.clientWidth) {
                            const buttonRect = button.getBoundingClientRect();
                            const containerRect = container.getBoundingClientRect();
                            const buttonCenter = (buttonRect.left + buttonRect.right) / 2;
                            const containerCenter = (containerRect.left + containerRect.right) / 2;
                            const delta = buttonCenter - containerCenter;

                            container.scrollBy({
                                left: delta,
                                behavior: 'smooth'
                            });
                        }
                    }
                    
                    this.tabbedContent.forEach((slide) => {
                        const slideType = slide.dataset.type;
                        const buttonType = button.dataset.type;
                        if(buttonType == slideType) {
                            slide.classList.add('active');
                        } else {
                            slide.classList.remove('active');
                        }
                    })
                });
            });
        }
    }

    updateLineIndicator(activeButton) {
        if (!activeButton || !this.tabbedNav || !this.tabIndicator) return;

        const navRect = this.tabbedNav.getBoundingClientRect();
        const buttonRect = activeButton.getBoundingClientRect();

        // Position indicator to span the full width of the button (no gaps)
        const left = buttonRect.left - navRect.left;
        const width = buttonRect.width;

        this.tabIndicator.style.left = `${left}px`;
        this.tabIndicator.style.width = `${width}px`;
    }
}